export const lowToHigh = (array) => {
  return array.slice(0).sort(
    (a, b) => a.product_prices[0].price - b.product_prices[0].price
  );
};

export const highToLow = (array) => {
  return array.slice(0).sort(
    (a, b) => b.product_prices[0].price - a.product_prices[0].price
  );
};

